import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z",
  stroke: "#292E36",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14 24.8799V23.1199C14 22.0799 14.85 21.2199 15.9 21.2199C17.71 21.2199 18.45 19.9399 17.54 18.3699C17.02 17.4699 17.33 16.2999 18.24 15.7799L19.97 14.7899C20.76 14.3199 21.78 14.5999 22.25 15.3899L22.36 15.5799C23.26 17.1499 24.74 17.1499 25.65 15.5799L25.76 15.3899C26.23 14.5999 27.25 14.3199 28.04 14.7899L29.77 15.7799C30.68 16.2999 30.99 17.4699 30.47 18.3699C29.56 19.9399 30.3 21.2199 32.11 21.2199C33.15 21.2199 34.01 22.0699 34.01 23.1199V24.8799C34.01 25.9199 33.16 26.7799 32.11 26.7799C30.3 26.7799 29.56 28.0599 30.47 29.6299C30.99 30.5399 30.68 31.6999 29.77 32.2199L28.04 33.2099C27.25 33.6799 26.23 33.3999 25.76 32.6099L25.65 32.4199C24.75 30.8499 23.27 30.8499 22.36 32.4199L22.25 32.6099C21.78 33.3999 20.76 33.6799 19.97 33.2099L18.24 32.2199C17.33 31.6999 17.02 30.5299 17.54 29.6299C18.45 28.0599 17.71 26.7799 15.9 26.7799C14.85 26.7799 14 25.9199 14 24.8799Z",
  stroke: "#292E36",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M40 1H8C4.13401 1 1 4.13401 1 8V40C1 43.866 4.13401 47 8 47H40C43.866 47 47 43.866 47 40V8C47 4.13401 43.866 1 40 1ZM8 0C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0H8Z",
      fill: _ctx.color || '#D6DBE1'
    }, null, 8, _hoisted_3),
    _hoisted_4,
    _hoisted_5
  ]))
}
}

})